import React from 'react';
import { checkString, checkArray } from '../helpers/global'

const Profile = props => {

  const {data} = props;
  console.log(data)
  let img_src = "";
  let img_alt = "";
  let focal_point = "";
  let combiStyle = {};
  if (checkArray(data.image_data)){
    img_src = data.image_data.toString();
  }
  if (!img_src) {

    img_src = data.image_url;
  }
  img_alt = data.image_alt;

  if (checkArray(data.focal_point)){
    focal_point = data.focal_point;
     combiStyle = {
      objectPosition: focal_point[0] + "%" + " " + focal_point[1] + "%"
    }
  }

  return (

    <div className={"grid-item col-3  "} >
      <a href={data.url} className={"grid-item-inner bg-"}>

        <div className="content">


          <h4 dangerouslySetInnerHTML={{__html: data.title}}/>
          <hr/>
          {checkString(data.job_title) &&
            <h5>{data.job_title}</h5>
          }
          {checkString(data.location) &&
            <h6>{data.location}</h6>
          }
          
      
          <hr/>
          {checkString(data.email_address) &&
            <p  dangerouslySetInnerHTML={{__html: data.email_address}} />
          }
    
          {checkString(data.text) &&
            <p className="slot-text" dangerouslySetInnerHTML={{__html: data.text}} />
          }
        




        </div>
      </a>
    </div>
  )
}

export default Profile;
